import { render, staticRenderFns } from "./WizardAdicionalAlerta.vue?vue&type=template&id=33cf2dc0&"
import script from "./WizardAdicionalAlerta.vue?vue&type=script&lang=js&"
export * from "./WizardAdicionalAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports